import { IS_PROD } from 'settings';

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
    gtag: any;
  }
}

type EventProps = {
  category: string;
  action: string;
  label?: string;
};

export const sendEventToGA = (event: EventProps) => {
  if (IS_PROD) {
    console.log(event);
  }
};
